// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".limit-list[data-v-0ecf070c]{height:100%}.limit-list .search-filter[data-v-0ecf070c]{height:30px;margin-bottom:10px;text-align:center}.limit-list[data-v-0ecf070c]  .el-table__empty-block{border-bottom:1px solid #e9e9e9;height:auto}.limit-list[data-v-0ecf070c]  .el-table__empty-block .el-table__empty-text{background:#fff;color:#999;font-size:14px;height:60px;line-height:60px;width:100%;text-align:center}", ""]);
// Exports
module.exports = exports;
